import { BILLING_STATUS_LABELS } from "@cdc-sccr/shared"

export type BillingStatus = "pendiente" | "controlado" | "liquidado" | "facturado" | "cerrado"

export { BILLING_STATUS_LABELS }

export const BILLING_STATUS_COLORS: Record<BillingStatus, string> = {
  pendiente:  "bg-muted text-muted-foreground",
  controlado: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400",
  liquidado:  "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  facturado:  "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  cerrado:    "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
}

export const ALL_BILLING_STATUSES: BillingStatus[] = [
  "pendiente", "liquidado", "controlado", "facturado", "cerrado",
]
